(function () {
  'use strict';

  var root = document.getElementById('rrxq');
  var configEl = document.getElementById('rrxq-config');
  if (!root || !configEl) return;

  var config = JSON.parse(configEl.textContent);
  var steps = config.steps;
  var currentIndex = 0;
  var answers = {};
  var transitioning = false;
  var timers = [];
  var testimonialTimer = null;
  var testimonialIndex = 0;
  var infoImageTimer = null;
  var infoImageIndex = 0;

  var mainEl = root.querySelector('[data-rrxq-main]');
  var progressWrap = root.querySelector('[data-rrxq-progress]');
  var progressBar = root.querySelector('[data-rrxq-progress-bar]');

  function clearTimers() {
    timers.forEach(function (id) { window.clearTimeout(id); });
    timers = [];
    if (testimonialTimer) {
      window.clearInterval(testimonialTimer);
      testimonialTimer = null;
    }
    if (infoImageTimer) {
      window.clearInterval(infoImageTimer);
      infoImageTimer = null;
    }
  }

  function schedule(fn, ms) {
    var id = window.setTimeout(fn, ms);
    timers.push(id);
    return id;
  }

  function progressSteps() {
    return steps.filter(function (s) {
      return s.type === 'single' || s.type === 'intro';
    }).length;
  }

  function progressIndex() {
    var count = 0;
    for (var i = 0; i <= currentIndex; i++) {
      if (steps[i].type === 'single' || (steps[i].type === 'intro' && i < currentIndex)) {
        count++;
      }
    }
    return count;
  }

  function updateProgress() {
    var step = steps[currentIndex];
    var show = currentIndex > 0 && step.type !== 'results' && step.type !== 'loader';
    progressWrap.classList.toggle('is-visible', show);
    if (!show) {
      progressBar.style.width = '0%';
      return;
    }
    var total = progressSteps();
    var current = progressIndex();
    var pct = Math.min(100, Math.round((current / total) * 100));
    progressBar.style.width = pct + '%';
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildCtaUrl() {
    var target = new URL(config.ctaUrl, window.location.origin);
    var sourceParams = new URLSearchParams(window.location.search);

    /* Generic passthrough: forward the ENTIRE incoming query string, never an
       allowlist — ad_name carries the personalization identity and non-utm
       params get added over time (see .cursor/rules/regenrx-change-guardrails).
       Params the target URL sets explicitly (and our own quiz=true below) win
       on collision; preview_theme_id passes through so preview stays preview. */
    sourceParams.forEach(function (value, key) {
      /* `view` is Shopify's template switcher for the current page type.
         Forwarding it onto the PDP would request a missing product template. */
      if (key === 'view') return;
      if (!target.searchParams.has(key)) {
        target.searchParams.set(key, value);
      }
    });

    target.searchParams.set('quiz', 'true');
    return target.toString();
  }

  function verifiedBadge() {
    return '<span class="rrx-verified" aria-label="Verified Customer"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  }

  function renderTestimonialSlide(t, verifiedLabel, isActive) {
    var activeClass = isActive ? ' is-active' : '';
    var html = '<article class="rrxq-testimonial__slide' + activeClass + '">';
    html += '<img class="rrxq-testimonial__photo" src="' + escapeHtml(t.image) + '" alt="' + escapeHtml(t.imageAlt || 'RegenRx customer') + '" width="44" height="44" loading="lazy">';
    html += '<div class="rrxq-testimonial__content">';
    html += '<p class="rrxq-testimonial__quote">&ldquo;' + escapeHtml(t.quote) + '&rdquo;</p>';
    html += '<p class="rrxq-testimonial__author"><span class="rrxq-testimonial__name">' + escapeHtml(t.name) + '</span> ';
    html += '<span class="rrxq-testimonial__verified">' + escapeHtml(verifiedLabel) + ' ' + verifiedBadge() + '</span></p>';
    html += '</div></article>';
    return html;
  }

  function renderTestimonialCarousel(items, verifiedLabel) {
    var html = '<div class="rrxq-testimonial" data-rrxq-testimonials aria-live="polite">';
    html += '<div class="rrxq-testimonial__viewport">';
    items.forEach(function (t, i) {
      html += renderTestimonialSlide(t, verifiedLabel, i === 0);
    });
    html += '</div></div>';
    return html;
  }

  function initCarousel(rootEl, slideSelector, intervalMs, timerRef, indexRef) {
    if (timerRef.current) {
      window.clearInterval(timerRef.current);
      timerRef.current = null;
    }
    if (!rootEl) return;
    var slides = rootEl.querySelectorAll(slideSelector);
    if (slides.length <= 1) return;
    indexRef.current = 0;
    timerRef.current = window.setInterval(function () {
      slides[indexRef.current].classList.remove('is-active');
      indexRef.current = (indexRef.current + 1) % slides.length;
      slides[indexRef.current].classList.add('is-active');
    }, intervalMs);
  }

  function initTestimonialCarousel() {
    initCarousel(
      mainEl.querySelector('[data-rrxq-testimonials]'),
      '.rrxq-testimonial__slide',
      5500,
      { get current() { return testimonialTimer; }, set current(v) { testimonialTimer = v; } },
      { get current() { return testimonialIndex; }, set current(v) { testimonialIndex = v; } }
    );
  }

  function initInfoImageCarousel(step) {
    initCarousel(
      mainEl.querySelector('[data-rrxq-info-images]'),
      '.rrxq-info-carousel__slide',
      step.imageCarouselMs || 4500,
      { get current() { return infoImageTimer; }, set current(v) { infoImageTimer = v; } },
      { get current() { return infoImageIndex; }, set current(v) { infoImageIndex = v; } }
    );
  }

  function renderIntro(step) {
    var meta = config.meta;
    var items = meta.testimonials || [];
    var verifiedLabel = meta.verifiedLabel || 'Verified Customer';
    var html = '';
    html += '<div class="rrxq-step" data-step-id="' + escapeHtml(step.id) + '">';
    html += '<h1 class="rrxq-headline">' + meta.headline + '</h1>';
    html += '<p class="rrxq-intro-note">';
    html += '<span class="rrxq-intro-note__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    html += '<span class="rrxq-intro-note__text">' + escapeHtml(meta.introBody) + '</span></p>';
    if (items.length) {
      html += renderTestimonialCarousel(items, verifiedLabel);
    }
    html += '<h2 class="rrxq-question">' + escapeHtml(step.prompt) + '</h2>';
    html += renderOptions(step);
    if (meta.footer) {
      html += '<p class="rrxq-footer-note">' + escapeHtml(meta.footer) + '</p>';
    }
    html += '</div>';
    return html;
  }

  function renderOptions(step) {
    var html = '<div class="rrxq-options" role="list">';
    step.options.forEach(function (opt) {
      html += '<button type="button" class="rrxq-option" role="listitem" data-value="' + escapeHtml(opt.value) + '" data-step="' + escapeHtml(step.id) + '">';
      if (opt.emoji) {
        html += '<span class="rrxq-option__emoji" aria-hidden="true">' + opt.emoji + '</span>';
      }
      html += '<span>' + escapeHtml(opt.label) + '</span></button>';
    });
    html += '</div>';
    return html;
  }

  function renderSingle(step) {
    var html = '<div class="rrxq-step" data-step-id="' + escapeHtml(step.id) + '">';
    html += '<h2 class="rrxq-question">' + escapeHtml(step.prompt) + '</h2>';
    html += renderOptions(step);
    if (step.whyWeAsk) {
      html += '<div class="rrxq-why"><button type="button" class="rrxq-why__toggle" data-why-toggle>';
      html += escapeHtml(step.whyWeAsk.heading || 'Why we ask');
      html += '<span aria-hidden="true">▾</span></button>';
      html += '<div class="rrxq-why__body">' + escapeHtml(step.whyWeAsk.body) + '</div></div>';
    }
    html += '</div>';
    return html;
  }

  function renderInfoImageCarousel(images) {
    var html = '<div class="rrxq-info-carousel" data-rrxq-info-images aria-live="polite">';
    html += '<div class="rrxq-info-carousel__viewport">';
    images.forEach(function (img, i) {
      var activeClass = i === 0 ? ' is-active' : '';
      html += '<figure class="rrxq-info-carousel__slide' + activeClass + '">';
      html += '<img class="rrxq-info-image" src="' + escapeHtml(img.src) + '" alt="' + escapeHtml(img.alt || '') + '" width="' + (img.width || 640) + '" height="' + (img.height || 480) + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '" decoding="async"' + (i === 0 ? ' fetchpriority="high"' : '') + '>';
      html += '</figure>';
    });
    html += '</div></div>';
    return html;
  }

  function renderInfo(step) {
    var html = '<div class="rrxq-step" data-step-id="' + escapeHtml(step.id) + '">';
    html += '<h2 class="rrxq-info-heading">' + escapeHtml(step.heading) + '</h2>';
    if (step.body && step.body.length) {
      step.body.forEach(function (p) {
        html += '<p class="rrxq-info-body">' + escapeHtml(p) + '</p>';
      });
    }
    if (step.images && step.images.length) {
      html += renderInfoImageCarousel(step.images);
    } else if (step.image) {
      html += '<img class="rrxq-info-image" src="' + escapeHtml(step.image.src) + '" alt="' + escapeHtml(step.image.alt || '') + '" width="' + (step.image.width || 640) + '" height="' + (step.image.height || 480) + '" loading="eager" decoding="async" fetchpriority="high">';
    }
    html += '<button type="button" class="rrxq-cta" data-continue><span>Continue</span><span class="rrxq-cta__arrow" aria-hidden="true">→</span></button>';
    html += '</div>';
    return html;
  }

  function loaderIcon(name) {
    var icons = {
      chart: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M7 14l3-3 3 2 4-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      sync: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 7h11l-2-2M17 17H6l2 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 7l-2 2v4M17 17l2-2v-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      calibrate: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="5" width="16" height="12" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M9 12h2l1-2 2 4 1-2h2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      sparkle: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3l1.4 4.3L18 9l-4.6 1.7L12 15l-1.4-4.3L6 9l4.6-1.7L12 3Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M18 14l.8 2.5 2.5.8-2.5.8-.8 2.5-.8-2.5-2.5-.8 2.5-.8.8-2.5Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>'
    };
    return icons[name] || icons.chart;
  }

  function metricIcon(name) {
    var icons = {
      bolt: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M13 2 5 14h6l-1 8 8-12h-6l1-8Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
      clock: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="8" stroke="currentColor" stroke-width="1.6"/><path d="M12 8v4l3 2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
      pulse: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h3l2-5 4 10 2-5h5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      steps: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 16V8M12 18v-6M17 14V6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
    };
    return icons[name] || icons.pulse;
  }

  function buildPersonalization() {
    var p = config.personalization || {};
    var declineMap = p.declineMap || {
      'few-months': 'ACUTE',
      'past-year': 'MODERATE',
      'over-year': 'GRADUAL',
      'not-sure': 'UNCERTAIN'
    };
    var primaryMap = p.primaryMap || {
      balance: 'STABILIZER WEAKNESS',
      'fear-falling': 'BALANCE CONFIDENCE',
      shuffle: 'STRIDE COMPENSATION',
      recovery: 'MUSCLE FATIGUE',
      activities: 'ENDURANCE DROP',
      independence: 'MOBILITY LIMIT'
    };
    var secondaryMap = p.secondaryMap || {
      '2-plus-days': 'SLOW RECOVERY',
      '1-2-days': 'MUSCLE FATIGUE',
      'hours': 'COMPENSATION',
      barely: 'EARLY STAGE'
    };
    var hookMap = p.hookMap || {
      balance: 'Stabilizer muscles in your feet are likely under-activated, not worn out.',
      'fear-falling': 'Your caution pattern points to retrainable balance confidence, not inevitable decline.',
      shuffle: 'A shorter stride often means compensating muscles are working overtime.',
      recovery: 'Slow recovery is a signal your foot stabilizers need reactivation, not rest alone.',
      activities: 'Keeping up gets harder when intrinsic foot muscles stop firing with every step.',
      independence: 'Mobility limits often start in the feet long before they show up elsewhere.'
    };

    var fields = p.fields || {};
    var primaryField = fields.primary || 'concern';
    var declineField = fields.decline || 'when-started';
    var secondaryField = fields.secondary || 'recovery-time';
    var scoreAField = fields.scoreA || 'confidence';
    var scoreBField = fields.scoreB || 'precautions';
    var scoreBYes = fields.scoreBYes || 'yes';
    var recoveryField = fields.recovery || 'recovery-time';
    var activityField = fields.activity || 'activity-level';
    var boostField = fields.boost || 'normal-for-age';
    var boostYes = fields.boostYes || 'often';

    var confScores = p.confScores || { 'not-confident': 3, cautious: 2, 'mostly-fine': 1, steady: 0 };
    var recoveryScores = p.recoveryScores || { '2-plus-days': 15, '1-2-days': 10, hours: 5, barely: 0 };
    var activityScores = p.activityScores || { sedentary: 12, 'less-active': 8, moderate: 4, 'very-active': 0 };

    var gaugeScore = typeof p.gaugeBase === 'number' ? p.gaugeBase : 38;
    gaugeScore += (confScores[answers[scoreAField]] || 1) * (typeof p.confWeight === 'number' ? p.confWeight : 12);
    if (answers[scoreBField] === scoreBYes) gaugeScore += typeof p.scoreBWeight === 'number' ? p.scoreBWeight : 10;
    gaugeScore += recoveryScores[answers[recoveryField]] || 5;
    gaugeScore += activityScores[answers[activityField]] || 4;
    if (answers[boostField] === boostYes) gaugeScore += typeof p.boostWeight === 'number' ? p.boostWeight : 6;
    gaugeScore = Math.min(92, Math.max(42, gaugeScore));

    var impactScore = (confScores[answers[scoreAField]] || 2) + (answers[scoreBField] === scoreBYes ? 1 : 0);
    var impactMap = p.impactMap || { high: 'HIGH', mid: 'ELEVATED', low: 'MODERATE' };
    var mobilityImpact = impactScore >= 3 ? impactMap.high : impactScore >= 2 ? impactMap.mid : impactMap.low;
    var gaugeLabel = gaugeScore >= 72 ? 'ELEVATED' : gaugeScore >= 58 ? 'MODERATE' : 'LOW-MODERATE';

    return {
      declinePattern: declineMap[answers[declineField]] || (p.defaults && p.defaults.decline) || 'MODERATE',
      primaryCause: primaryMap[answers[primaryField]] || (p.defaults && p.defaults.primary) || 'STABILIZER WEAKNESS',
      secondaryCause: secondaryMap[answers[secondaryField]] || (p.defaults && p.defaults.secondary) || 'MUSCLE FATIGUE',
      mobilityImpact: mobilityImpact,
      gaugePct: gaugeScore,
      gaugeLabel: gaugeLabel,
      hook: hookMap[answers[primaryField]] || (p.defaults && p.defaults.hook) || 'Your answers point to underused foot muscles, not permanent aging.'
    };
  }

  function loaderProgressRing() {
    return '<svg class="rrxq-loader__ring" viewBox="0 0 24 24" aria-hidden="true">' +
      '<circle class="rrxq-loader__ring-track" cx="12" cy="12" r="9.5"></circle>' +
      '<circle class="rrxq-loader__ring-fill" cx="12" cy="12" r="9.5"></circle>' +
      '</svg>';
  }

  function restartLoaderRing(taskEl) {
    var fill = taskEl.querySelector('.rrxq-loader__ring-fill');
    if (!fill) return;
    fill.style.animation = 'none';
    void fill.offsetWidth;
    fill.style.animation = '';
  }

  function activateLoaderTask(taskEl, stepMs) {
    taskEl.style.setProperty('--task-step-ms', stepMs + 'ms');
    taskEl.classList.add('is-active');
    restartLoaderRing(taskEl);
  }

  function renderLoaderTaskList(step) {
    var html = '<div class="rrxq-step rrxq-loader-step" data-step-id="' + escapeHtml(step.id) + '">';
    html += '<div class="rrxq-loader rrxq-loader--steps rrxq-loader--task-list">';
    html += '<h2 class="rrxq-loader__title">' + escapeHtml(step.heading) + '</h2>';
    if (step.subtitle) {
      html += '<p class="rrxq-loader__subtitle">' + escapeHtml(step.subtitle) + '</p>';
    }
    html += '<ul class="rrxq-loader__tasks" aria-live="polite">';
    (step.tasks || []).forEach(function (task, i) {
      html += '<li class="rrxq-loader__task' + (i === 0 ? ' is-active' : '') + '" data-task-index="' + i + '">';
      html += '<span class="rrxq-loader__task-icon">' + loaderIcon(task.icon) + '</span>';
      html += '<span class="rrxq-loader__task-label">' + escapeHtml(task.label) + '</span>';
      html += '<span class="rrxq-loader__task-status" aria-hidden="true">';
      html += '<span class="rrxq-loader__check"><svg viewBox="0 0 24 24" fill="none"><path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      html += loaderProgressRing();
      html += '</span></li>';
    });
    html += '</ul>';
    if (step.footer) {
      html += '<p class="rrxq-loader__footer">' + escapeHtml(step.footer) + '</p>';
    }
    html += '</div></div>';
    return html;
  }

  function renderCircularLoaderSteps(step) {
    var tasks = step.tasks || [];
    var durationMs = step.autoAdvanceMs || (tasks.length * (step.taskStepMs || 900)) || 4800;
    var progressTarget = step.progressTarget || 87;
    var progressOffset = 100 - progressTarget;
    var firstTaskLabel = tasks[0] ? tasks[0].label : 'Analyzing';
    var html = '<div class="rrxq-step rrxq-loader-step" data-step-id="' + escapeHtml(step.id) + '">';
    html += '<div class="rrxq-loader rrxq-loader--steps" style="--loader-duration-ms: ' + durationMs + 'ms; --loader-progress-offset: ' + progressOffset + ';">';
    html += '<h2 class="rrxq-loader__title">' + escapeHtml(step.heading) + '</h2>';
    if (step.subtitle) {
      html += '<p class="rrxq-loader__subtitle">' + escapeHtml(step.subtitle) + '</p>';
    }
    html += '<div class="rrxq-loader__progress" role="progressbar" aria-label="' + escapeHtml(step.heading) + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + progressTarget + '">';
    html += '<svg class="rrxq-loader__progress-ring" viewBox="0 0 160 160" aria-hidden="true">';
    html += '<circle class="rrxq-loader__progress-track" cx="80" cy="80" r="58" pathLength="100"></circle>';
    html += '<circle class="rrxq-loader__progress-fill" cx="80" cy="80" r="58" pathLength="100"></circle>';
    html += '</svg>';
    html += '<span class="rrxq-loader__progress-value" data-loader-percent>0%</span>';
    html += '</div>';
    html += '<p class="rrxq-loader__progress-label" data-loader-label aria-live="polite">' + escapeHtml(firstTaskLabel) + '</p>';
    html += '<div class="rrxq-loader__task-data" hidden>';
    tasks.forEach(function (task, i) {
      html += '<span data-task-index="' + i + '" data-task-label="' + escapeHtml(task.label) + '"></span>';
    });
    html += '</div>';
    if (step.footer) {
      html += '<p class="rrxq-loader__footer">' + escapeHtml(step.footer) + '</p>';
    }
    html += '</div></div>';
    return html;
  }

  function renderLoaderSteps(step) {
    if (step.id !== 'info-analyzing') {
      return renderLoaderTaskList(step);
    }
    return renderCircularLoaderSteps(step);
  }

  function initLoaderSteps(step) {
    var tasks = mainEl.querySelectorAll('.rrxq-loader__task');
    if (tasks.length) {
      var taskStepMs = step.taskStepMs || 900;
      var taskIndex = 0;

      activateLoaderTask(tasks[0], taskStepMs);

      function advanceTask() {
        tasks[taskIndex].classList.remove('is-active');
        tasks[taskIndex].classList.add('is-done');
        taskIndex++;
        if (taskIndex < tasks.length) {
          activateLoaderTask(tasks[taskIndex], taskStepMs);
          schedule(advanceTask, taskStepMs);
        }
      }

      schedule(advanceTask, taskStepMs);
      return;
    }

    var taskData = mainEl.querySelectorAll('[data-task-label]');
    var labelEl = mainEl.querySelector('[data-loader-label]');
    var percentEl = mainEl.querySelector('[data-loader-percent]');
    var durationMs = step.autoAdvanceMs || (taskData.length * (step.taskStepMs || 900)) || 4800;
    var progressTarget = step.progressTarget || 87;
    var stepMs = taskData.length ? Math.max(400, Math.round(durationMs / taskData.length)) : (step.taskStepMs || 900);
    var index = 0;
    var start = window.performance.now();

    if (percentEl) {
      function updatePercent(now) {
        var elapsed = Math.min(1, (now - start) / durationMs);
        var eased = 1 - Math.pow(1 - elapsed, 3);
        percentEl.textContent = Math.round(eased * progressTarget) + '%';
        if (elapsed < 1) {
          schedule(function () {
            window.requestAnimationFrame(updatePercent);
          }, 80);
        }
      }
      window.requestAnimationFrame(updatePercent);
    }

    function advance() {
      index++;
      if (index < taskData.length) {
        if (labelEl) {
          labelEl.textContent = taskData[index].getAttribute('data-task-label');
        }
        schedule(advance, stepMs);
      }
    }

    if (taskData.length > 1) {
      schedule(advance, stepMs);
    }
  }

  function renderLoader(step) {
    if (step.variant === 'steps' || (step.tasks && step.tasks.length)) {
      return renderLoaderSteps(step);
    }
    var html = '<div class="rrxq-step" data-step-id="' + escapeHtml(step.id) + '">';
    html += '<div class="rrxq-loader">';
    html += '<h2 class="rrxq-loader__title">' + escapeHtml(step.heading) + '</h2>';
    if (step.body && step.body.length) {
      step.body.forEach(function (p) {
        html += '<p class="rrxq-loader__body">' + escapeHtml(p) + '</p>';
      });
    }
    html += '<div class="rrxq-loader__track" aria-hidden="true"><div class="rrxq-loader__bar"></div></div>';
    html += '<div class="rrxq-loader__dots" aria-hidden="true"><i></i><i></i><i></i></div>';
    html += '</div></div>';
    return html;
  }

  function renderResultMetric(label, value, icon, accent) {
    var accentClass = accent ? ' rrxq-result-metric--accent' : '';
    var html = '<article class="rrxq-result-metric' + accentClass + '">';
    html += '<span class="rrxq-result-metric__icon">' + metricIcon(icon) + '</span>';
    html += '<span class="rrxq-result-metric__label">' + escapeHtml(label) + '</span>';
    html += '<strong class="rrxq-result-metric__value">' + escapeHtml(value) + '</strong>';
    html += '</article>';
    return html;
  }

  function renderResults(step) {
    var profile = buildPersonalization();
    var ctaUrl = buildCtaUrl();
    var ui = config.resultsUi || {};
    var metrics = ui.metrics || [
      { label: 'Decline Pattern', key: 'declinePattern', icon: 'bolt', accent: true },
      { label: 'Primary Root Cause', key: 'primaryCause', icon: 'clock', accent: false },
      { label: 'Secondary Root Cause', key: 'secondaryCause', icon: 'pulse', accent: false },
      { label: 'Mobility Impact', key: 'mobilityImpact', icon: 'steps', accent: true }
    ];
    var html = '<div class="rrxq-step rrxq-results" data-step-id="' + escapeHtml(step.id) + '">';

    html += '<div class="rrxq-result-card">';
    html += '<div class="rrxq-result-card__hero">';
    html += '<span class="rrxq-result-card__alert" aria-hidden="true">!</span>';
    html += '<div class="rrxq-result-card__intro">';
    html += '<h2 class="rrxq-result-title"><span class="rrxq-result-title__text">' + escapeHtml(step.assessmentLabel || 'Your Foot Strength Assessment:') + '</span> ';
    html += '<span class="rrxq-result-pill">' + escapeHtml(step.badgeLabel || 'RETRAINABLE') + '</span></h2>';
    html += '<p class="rrxq-result-card__hook">' + escapeHtml(profile.hook) + '</p>';
    html += '</div></div>';

    html += '<div class="rrxq-result-gauge" data-gauge-pct="' + profile.gaugePct + '">';
    html += '<div class="rrxq-result-gauge__head">';
    html += '<span class="rrxq-result-gauge__title">' + escapeHtml(ui.gaugeTitle || 'Level of Foot Muscle Deactivation') + '</span>';
    html += '<span class="rrxq-result-pill rrxq-result-pill--soft">' + escapeHtml(profile.gaugeLabel) + '</span>';
    html += '</div>';
    html += '<div class="rrxq-result-gauge__track" aria-hidden="true">';
    html += '<div class="rrxq-result-gauge__gradient"></div>';
    html += '<div class="rrxq-result-gauge__thumb"></div>';
    html += '</div>';
    html += '<div class="rrxq-result-gauge__scale"><span>Low</span><span>High</span></div>';
    html += '</div></div>';

    html += '<div class="rrxq-result-grid">';
    metrics.forEach(function (metric) {
      html += renderResultMetric(metric.label, profile[metric.key], metric.icon, !!metric.accent);
    });
    html += '</div>';

    if (ui.fix || (ui.offerItems && ui.offerItems.length)) {
      if (ui.fix) {
        html += '<p class="rrxq-result-copy">' + escapeHtml(ui.fix) + '</p>';
      }
      if (ui.offerItems && ui.offerItems.length) {
        html += '<ul class="rrxq-result-list">';
        ui.offerItems.forEach(function (item) {
          html += '<li>' + escapeHtml(item) + '</li>';
        });
        html += '</ul>';
      }
    }

    html += '<a class="rrxq-cta rrxq-cta--results" href="' + escapeHtml(ctaUrl) + '"><span>' + escapeHtml(step.ctaLabel || "Show Me What's Possible") + '</span><span class="rrxq-cta__arrow" aria-hidden="true">→</span></a>';
    if (step.disclaimer) {
      html += '<p class="rrxq-disclaimer">' + escapeHtml(step.disclaimer) + '</p>';
    }
    html += '</div>';
    return html;
  }

  function initResultsAnimations() {
    var profile = buildPersonalization();
    schedule(function () {
      var card = mainEl.querySelector('.rrxq-result-card');
      if (card) card.classList.add('is-visible');
    }, 80);

    schedule(function () {
      var gauge = mainEl.querySelector('.rrxq-result-gauge');
      if (gauge) {
        gauge.classList.add('is-animated');
        gauge.style.setProperty('--gauge-pct', profile.gaugePct + '%');
      }
    }, 420);

    mainEl.querySelectorAll('.rrxq-result-metric').forEach(function (el, idx) {
      schedule(function () {
        el.classList.add('is-visible');
      }, 560 + idx * 110);
    });
  }

  function renderStep(step) {
    if (step.type === 'intro') return renderIntro(step);
    if (step.type === 'single') return renderSingle(step);
    if (step.type === 'info') return renderInfo(step);
    if (step.type === 'loader') return renderLoader(step);
    if (step.type === 'results') return renderResults(step);
    return '';
  }

  function bindStepEvents(step) {
    mainEl.querySelectorAll('.rrxq-option').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (transitioning) return;
        var stepId = btn.getAttribute('data-step');
        var value = btn.getAttribute('data-value');
        selectOption(stepId, value, btn);
      });
    });

    var continueBtn = mainEl.querySelector('[data-continue]');
    if (continueBtn) {
      continueBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (transitioning) return;
        goNext(0);
      });
    }

    var whyToggle = mainEl.querySelector('[data-why-toggle]');
    if (whyToggle) {
      whyToggle.addEventListener('click', function () {
        whyToggle.closest('.rrxq-why').classList.toggle('is-collapsed');
      });
    }

    if (step.type === 'loader' && step.autoAdvanceMs) {
      schedule(function () { goNext(0); }, step.autoAdvanceMs);
    }

    if (step.type === 'loader' && step.tasks && step.tasks.length) {
      initLoaderSteps(step);
    }

    if (step.type === 'results') {
      initResultsAnimations();
    }
  }

  function paint() {
    clearTimers();
    var step = steps[currentIndex];
    mainEl.innerHTML = renderStep(step);
    bindStepEvents(step);
    updateProgress();
    root.setAttribute('data-rrxq-step', step.id);
    window.scrollTo(0, 0);
    if (step.type === 'intro') {
      initTestimonialCarousel();
    }
    if (step.type === 'info' && step.images && step.images.length > 1) {
      initInfoImageCarousel(step);
    }
  }

  function goNext(delay) {
    if (transitioning) return;
    transitioning = true;
    var outgoing = mainEl.querySelector('.rrxq-step');
    if (outgoing) outgoing.classList.add('is-exiting');

    schedule(function () {
      currentIndex++;
      if (currentIndex >= steps.length) currentIndex = steps.length - 1;
      paint();
      transitioning = false;
    }, delay || 320);
  }

  function selectOption(stepId, value, btn) {
    answers[stepId] = value;
    mainEl.querySelectorAll('.rrxq-option').forEach(function (el) {
      el.disabled = true;
      el.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
    schedule(function () { goNext(280); }, 420);
  }

  document.documentElement.classList.add('rrxq-js');
  paint();
})();
